














































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import SchedulerInfo from '@/components/Stats/SchedulerStats/SchedulerInfo/index.vue';
import Format from '@/util/Format';
import StatsUtil from '@/util/StatsUtil';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    SchedulerInfo,
  },
})
export default class SchedulerTable extends Vue {
  @PropSync('eventItems', {}) eventItemSync!: [];

  @PropSync('eventCount', {}) eventCountSync!: [];

  @PropSync('marketSelected', {}) marketSelect!: any;

  @PropSync('loading', {}) loadings!: any;

  private tempScheduledEvents: any;

  public seeList: boolean = true;

  private headers: any = [];

  public mounted() {
    if (UserModule.currentRole === 'fw_manager'
      || UserModule.currentRole === 'fw_admin') {
      this.headers = [
        {
          text: 'Restaurant',
          align: 'left',
          value: 'partnerName',
          width: '195px',
        },
        {
          text: 'Unit Name',
          align: 'left',
          value: 'unitName',
          width: '220px',
        },
        {
          text: 'Market',
          align: 'left',
          value: 'marketName',
          width: '110px',
        },
        {
          text: 'Event Date',
          align: 'left',
          value: 'date',
          width: '140px',
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status',
          width: '140px',
        },
      ];
    } else {
      this.headers = [
        {
          text: 'Unit Name',
          align: 'left',
          value: 'unitName',
          width: '220px',
        },
        {
          text: 'Event Date',
          align: 'left',
          value: 'date',
          width: '140px',
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status',
          width: '140px',
        },
      ];
    }
  }

  public get filteredItems() {
    this.tempScheduledEvents = JSON.parse(JSON.stringify(this.eventItemSync));
    /* eslint-disable no-param-reassign */
    const filteredEvents = this.tempScheduledEvents
      .filter((event: any) => StatsUtil.getFilteredEventsTableByStatus(event))
      .map((event: any) => {
        event.status = Format.capitalize(event.status);
        event.status = this.getEventStatus(event);
        return event;
      });
    return filteredEvents;
  }

  public getEventStatus(event: any) {
    if (event.status === 'Live') {
      return 'Accepted';
    }

    return event.status;
  }

  getColor(status: string) {
    if (status === 'Accepted'
      || status === 'Live') return 'status-green';
    if (status === 'Canceled'
      || status === 'Declined') return 'status-red';
    if (status === 'NoResponse'
      || status === 'NoShow') return 'status-grey';
    if (status === 'Pending') return 'status-golden';
    return '';
  }

  public get userRole() {
    return UserModule.currentRole;
  }

  public onClickSee() {
    this.seeList = false;
  }
}
